<template>
  <div class="hidden lg:flex bg-gray-900 py-2 px-4 md:px-8 gap-4 md:gap-6 justify-end text-white text-xs ">
    <router-link :to="{name: 'ContactPage'}">
      Contact
    </router-link>
    <a href=""> Support Center </a>
  </div>
  <div class="flex flex-col gap-3 pt-3 md:pt-5 px-4 md:px-8">
    <tw-navbar-home ref="menu" :user="currentUser" />
    <!-- mobile search -->
    <home-search class="md:hidden" />
  </div>
</template>

<script>
import { mapActions, mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import HomeSearch from '@/components/home/home-search.vue'
import TwNavbarHome from '@/components/generic/navbar/tw-navbar-home.vue'

export default {
  name: "FrontPageTopNavigation",
  components: { TwNavbarHome, HomeSearch },
  computed: {
    ...mapStores(useAuthStore),
    currentUser() {
      return useAuthStore().user
    },
  },
  methods: {

  },
}
</script>
